import { Icon, Tooltip } from '@snapchat/snap-design-system-marketing';
import type { FC } from 'react';

import {
  actionButtonCss,
  actionButtonIconNudgeCss,
  messageActionsCss,
} from './MessageActions.styles';

interface MessageActionsProps {
  id: string;
  allowRedo?: boolean;
  onCopy?: () => void;
  onRedo?: () => void;
}

export const MessageActions: FC<MessageActionsProps> = ({ id, allowRedo, onCopy, onRedo }) => (
  <div className={messageActionsCss}>
    <Tooltip uniqueId={`${id}-copy`} content="Copy" place="bottom">
      <button className={actionButtonCss} type="button" aria-label="Copy" onClick={onCopy}>
        <Icon className={actionButtonIconNudgeCss} name="copy" size={16} />
      </button>
    </Tooltip>
    {allowRedo && (
      <Tooltip uniqueId={`${id}-redo`} content="Redo" place="bottom">
        <button className={actionButtonCss} type="button" aria-label="Redo" onClick={onRedo}>
          <Icon name="refresh" size={16} />
        </button>
      </Tooltip>
    )}
  </div>
);

MessageActions.displayName = 'MessageActions';
